/**
 * Utility functions for player-related operations
 */

/**
 * Check if a player is missing or has unconfirmed registration for a specific season
 * @param {Object} player - The player object
 * @param {Object} season - The season object containing seasonId and playerRegFeeMandatory
 * @returns {boolean} - True if player is missing or unconfirmed registration, false otherwise
 */
export const isUnconfirmedOrMissing = (player, season) => {
  if (!season?.playerRegFeeMandatory || !season?.playerRegMandatory || !season?.seasonId || !player) {
    return false;
  }
  
  const regs = player.SeasonPlayerRegistrations || [];
  const reg = regs.find(r => r.Season?.seasonId === season.seasonId);
  
  if (!reg) {
    return true; // missing registration
  }
  
  return !reg.isConfirmed;
};
